import { Navigate, Outlet } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";

const AnonymousRoute = () => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  return authStatus === "authenticated" ? <Navigate to="/" /> : <Outlet />;
};

export default AnonymousRoute;
